export enum GtmEvents {
  ViewItemList = `view_item_list`,
  ViewItem = `view_item`,
  Login = `login`,
  LoginError = `login_error`,
  SelectItem = `select_item`,
  AddToCart = `add_to_cart`,
  AddToWishlist = `add_to_wishlist`,
  ViewCart = `view_cart`,
  RemoveFromCart = `remove_from_cart`,
  BeginCheckout = `begin_checkout`,
  AddShippingInfo = `add_shipping_info`,
  AddPaymentInfo = `add_payment_info`,
  Purchase = `purchase`,
  Quote = `quote`,
  PriceLookupVC = `price_lookup_vc`,
  QuickOrderTableDisplay = `quick_order_table_display`,
}

export enum LoginMethod {
  Local = 'LOCAL',
  Okta = 'OKTA',
}

export enum StoreTypeEnum {
  ValvStore = 'ValvStore'
}


export enum ItemListTypeEnum {
  Search = 'Search',
  ProductListing = 'Product Listing',
  ProductDetail = 'Product Details',
  QuickOrder = 'Quick Order',
  MyFavourite = 'My Favorites',
  Cart = 'Cart',
  Checkoutpage = 'Checkout Page',
  SavedCart = 'Saved Cart',
}

export type LoginMethodType = LoginMethod.Local | LoginMethod.Okta;

export type ItemListType =
  | ItemListTypeEnum.Search
  | ItemListTypeEnum.ProductListing
  | ItemListTypeEnum.ProductDetail
  | ItemListTypeEnum.QuickOrder
  | ItemListTypeEnum.MyFavourite
  | ItemListTypeEnum.Checkoutpage
  | ItemListTypeEnum.Cart
  | ItemListTypeEnum.SavedCart;

